import {
  type PricelistProductCreateInput,
  usePricelistProductCreateMutation,
} from "@/generated/graphql";

export const usePricelistProductCreate = () => {
  const [, createPricelistProductMutation] = usePricelistProductCreateMutation();

  const createPricelistProduct = (input: PricelistProductCreateInput) => {
    return createPricelistProductMutation({ input });
  };

  return {
    createPricelistProduct,
  };
};
